import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";

function Solutionled(props) {
  return (
    <section className="solutionled p-100">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
            <div className="example" data-text="Fintech App">
              <h2>Custom Logistic Software Development Company</h2>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <p>
              We are a top logistic app development company that provides modern
              transportation management and warehousing services to
              manufacturing and distribution companies.
            </p>
            <p>
              Our logistics app development services are aimed at improving the
              operational efficiency of our clients while providing flawless
              shipment services with exceptional user experiences.
            </p>
            <p>
              Being a top-rated logistics software development company, we
              strive to help clients streamline storage and delivery management
              capabilities with intelligent freight tracking, warehouse
              management, and class-apart supply chain solutions.
            </p>
            <div className="btn_talk">
              <Link
                to="/contact"
                className="border_btn"
                aria-label="TekRevol Contact"
              >
                Let's Connect!
              </Link>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Solutionled;
